import React, { Component } from 'react';
import { Spinner } from "react-bootstrap";
import { AppContext } from '../context/AppContext';

const columns = [
    { 'value': 'idEquipment', 'title': 'Id' },
    { 'value': 'equipmentName', 'title': 'Equipment Name' },
    { 'value': 'equipmentCode', 'title': 'Equipment Code' },
    { 'value': 'capacity', 'title': 'Capacity' },
    { 'value': 'yearOfManufacture', 'title': 'Year of Manufacture' },
    { 'value': 'makeName', 'title': 'Make' },
    { 'value': 'machineModel', 'title': 'Machine Model' },
    { 'value': 'fuelType', 'title': 'Fuel' },
    { 'value': 'projectName', 'title': 'Project' },
    { 'value': 'emoStatus', 'title': 'Emo Status' },
    { 'value': 'billingAmount', 'title': 'Rent' }
];

const url = process.env.REACT_APP_API_URL + "reports/project_wise_equipment_report";

class ProjectWiseEquipmentDt extends Component {
    static contextType = AppContext;
    constructor(props) {
        super(props);
        this.state = {
            entities: {
                data: [],
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 10,
                to: 1,
                total: 1,
            },
            first_page: 1,
            current_page: 1,
            sorted_column: columns[0].value,
            offset: 4,
            order: 'DESC',
            limit: '10',
            orderBy: 'idEquipment',
            orderType: 'ASC',
            globalSearch: '',
            columns: {
                'idEquipment': {
                    filterType: 'like',
                    filterValue: ''
                },
                'equipmentName': {
                    filterType: 'like',
                    filterValue: ''
                },
                'equipmentCode': {
                    filterType: 'like',
                    filterValue: ''
                },
                'capacity': {
                    filterType: 'like',
                    filterValue: ''
                },
                'yearOfManufacture': {
                    filterType: 'like',
                    filterValue: ''
                },
                'makeName': {
                    filterType: 'like',
                    filterValue: ''
                },
                'machineModel': {
                    filterType: 'like',
                    filterValue: ''
                },
                'fuelType': {
                    filterType: 'like',
                    filterValue: ''
                },
                'projectName': {
                    filterType: 'like',
                    filterValue: ''
                },
                'emoStatus': {
                    filterType: 'like',
                    filterValue: ''
                },
                'billingAmount': {
                    filterType: 'like',
                    filterValue: ''
                }
            }
        };
    }

    fetchEntities() {
        this.setState({ loading: true });
        let fetchUrl = `${url}?page=${this.state.current_page}&column=${this.state.sorted_column}&order=${this.state.order}&globalSearch=${this.state.globalSearch}&per_page=${this.state.entities.per_page}`;
        const jwt = this.context.jwt.token;
        fetch(fetchUrl, {
            method: "POST",
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwt },
            body: JSON.stringify(this.state)
        })
            .then((resp) => {
                return resp.json()
            })
            .then((response) => {
                this.setState({ entities: response.data.data, loading: false });

            })
            .catch((error) => {
                this.setState({ loading: false });
                console.log(error, "catch the hoop")
            });

    }

    changePage(pageNumber) {
        this.setState({ current_page: pageNumber }, () => { this.fetchEntities() });
    }

    changePerPage = evt => {

        this.setState({ entities: { ...this.state.entities, per_page: evt.target.value } }, () => { this.fetchEntities() });
    }

    changeGlobalSearch = evt => {
        this.setState({ globalSearch: evt.target.value }, () => { this.fetchEntities() });
    }

    columnsFilterChange = evt => {
        this.setState({
            columns: {
                ...this.state.columns, [evt.target.name]: {
                    filterType: 'like',
                    filterValue: evt.target.value
                },
            }
        }, () => { this.fetchEntities() });
    }


    onStatusChange = (evt) => {
        this.setState(
            {
                columns: {
                    ...this.state.columns,
                    status: {
                        filterType: "like",
                        filterValue: evt.target.value,
                    },
                },
            },
            () => {
                this.fetchEntities();
            }
        );
    };

    columnHead(value) {
        return value.split('_').join(' ');
    }

    pagesNumbers() {
        if (!this.state.entities.to) {
            return [];
        }
        let from = this.state.entities.current_page - this.state.offset;
        if (from < 1) {
            from = 1;
        }
        let to = from + (this.state.offset * 2);
        if (to >= this.state.entities.last_page) {
            to = this.state.entities.last_page;
        }
        let pagesArray = [];

        for (let page = from; page <= to; page++) {
            pagesArray.push(page);
        }
        return pagesArray;
    }

    componentDidMount() {
        this.setState({ current_page: this.state.entities.current_page, loading: true }, () => { this.fetchEntities() });
    }

    tableHeads() {
        let icon;
        if (this.state.order === 'asc') {
            icon = <i className="fa fa-arrow-up"></i>;
        } else {
            icon = <i className="fa fa-arrow-down"></i>;
        }
        return columns.map((column, index) => {
            if (column.value === 'action') {
                return <th style={{ "textAlign": "center" }} key={index}>
                    <p className="text-primary"> {column.title}</p>
                </th>
            }
            else {
                return <th style={{ "textAlign": "center" }} key={index} onClick={() => this.sortByColumn(column.value)}>
                    <p className="text-primary"> {this.columnHead(column.title)}{column.value === this.state.sorted_column && icon}</p>
                </th>
            }

        });
    }

    tableHeadFilter() {
        return columns.map((column, index) => {
            if (column.value === 'action' || column.value === "image") {
                return <td key={index}></td>
            }
            else if (column.value === 'status') {
                return (
                    <td key={index}>
                        <select className="form-control form-control-sm" onChange={this.onStatusChange} style={{ width: "max-content" }}>
                            <option value="">Select Status</option>
                            {
                                this.state.statusArr.map(function (item, id) {
                                    return <option key={id} value={item.value}>{item.label}</option>
                                })
                            }
                        </select>
                    </td>

                )

            }
            else {
                return <td key={index} >
                    <input type="text" name={column.value} value={this.state.columns[column.value].filterValue} onChange={this.columnsFilterChange} className="form-control form-control-sm" style={{ "borderColor": "#e4e6ef" }} />
                </td>
            }
        });

    }

    dataList() {
        if (this.state.entities.data.length) {
            return this.state.entities.data.map((value, key) => {
                return <tr key={key} >
                    <td className="text-center">{value.idEquipment}</td>
                    <td className="text-center">{value.equipmentName}</td>
                    <td className="text-center">{value.equipmentCode}</td>
                    <td className="text-center">{value.capacity}</td>
                    <td className="text-center">{value.yearOfManufacture}</td>
                    <td className="text-center">{value.makeName}</td>
                    <td className="text-center">{value.machineModel}</td>
                    <td className="text-center">{value.fuelType}</td>
                    <td className="text-center">{value.projectName}</td>
                    <td className="text-center">
                        {value.emoStatus === 'received' && <span className="label label-lg label-success label-inline mr-2">Received</span>}
                        {value.emoStatus === 'released' && <span className="label label-lg label-info label-inline mr-2">Released</span>}
                        {value.emoStatus === 'parked' && <span className="label label-lg label-warning label-inline mr-2">Parked</span>}
                        {value.emoStatus === 'denied' && <span className="label label-lg label-danger label-inline mr-2">Denied</span>}
                        {value.emoStatus === 'created' && <span className="label label-lg label-primary label-inline mr-2">Created</span>}
                        {value.emoStatus === 'buffered' && <span className="label label-lg label-warning label-inline mr-2">Buffered</span>}
                    </td>
                    <td className="text-right">{value.billingAmount}</td>
                </tr>
            })
        } else {
            return <tr>
                <td colSpan={columns.length} className="text-center">No Records Found.</td>
            </tr>
        }
    }


    sortByColumn(column) {
        if (column === this.state.sorted_column) {
            this.state.order === 'asc' ? this.setState({ order: 'desc', current_page: this.state.first_page }, () => { this.fetchEntities() }) : this.setState({ order: 'asc' }, () => { this.fetchEntities() });
        } else {
            this.setState({ sorted_column: column, order: 'asc', current_page: this.state.first_page }, () => { this.fetchEntities() });
        }
    }

    pageList() {
        return this.pagesNumbers().map(page => {
            return <li className={page === this.state.entities.current_page ? 'page-item active' : 'page-item'} key={page}>
                <button className="page-link" onClick={() => this.changePage(page)}>{page}</button>
            </li>
        })
    }

    render() {
        return (
            <>
                <div className="row">
                    <div className="col-md-2">
                        <select className="form-control form-control-sm" value={this.state.entities.per_page} onChange={this.changePerPage} style={{ "borderColor": "#e4e6ef" }}>
                            <option value="10">10</option>
                            <option value="100">100</option>
                            <option value="200">200</option>
                            <option value="500">500</option>
                            <option value="1000">1000</option>
                        </select>
                    </div>
                    <div className="pull-right col-md-6">
                        <input type="text" placeholder="Global Search" value={this.state.globalSearch} onChange={this.changeGlobalSearch} className="form-control form-control-sm" style={{ "borderColor": "#e4e6ef" }} />
                    </div>
                </div>
                <br />
                <div className="table-responsive" style={{ 'height': '550px', 'overflow': 'auto' }}>
                    <table className="table table-sm table-hover table-bordered table-condensed" style={{ minWidth: "max-content" }}>
                        <thead>
                            <tr>{this.tableHeads()}</tr>
                            <tr>
                                {
                                    this.tableHeadFilter()
                                }
                            </tr>
                        </thead>
                        <tbody>{this.state.loading ? <tr><td colSpan={columns.length} className="text-center"> <Spinner animation="grow" /><Spinner animation="grow" /><Spinner animation="grow" /></td></tr> : this.dataList()}</tbody>
                    </table>

                </div>
                {(this.state.entities.data && this.state.entities.data.length > 0) &&
                    <>
                        <div className="mt-5"></div>
                        <nav>
                            <ul className="pagination">
                                <li className="page-item">
                                    <button className="page-link" disabled={1 === this.state.entities.current_page} onClick={() => this.changePage(this.state.entities.current_page - 1)}>
                                        Previous
                                    </button>
                                </li>
                                {this.pageList()}
                                <li className="page-item">
                                    <button className="page-link" disabled={this.state.entities.last_page === this.state.entities.current_page} onClick={() => this.changePage(this.state.entities.current_page + 1)}>
                                        Next
                                    </button>
                                </li>
                                <span style={{ marginTop: '8px' }}> &nbsp; <i>Displaying {this.state.entities.data.length} of {this.state.entities.total} entries.</i></span>
                            </ul>
                        </nav>
                    </>
                }
            </>
        );
    }

}

export default ProjectWiseEquipmentDt;